import { render } from "./SearchResults.vue?vue&type=template&id=56c9b4a1&scoped=true"
import script from "./SearchResults.vue?vue&type=script&lang=js"
export * from "./SearchResults.vue?vue&type=script&lang=js"

import "./SearchResults.vue?vue&type=style&index=0&id=56c9b4a1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-56c9b4a1"

export default script